import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	useTheme,
} from '@mui/material';
import { addDistrict } from '../../api/content-api';
import { useContext, useState } from 'react';
import AuthContext from '../../store/auth-context';
import SnackbarContext from '../../store/snackbar-context';
import { useNavigate } from 'react-router-dom';
import { loginPage } from '../../store/fixed-routing';
import ManagedFormContext from '../../ui/Form/MangedForm';
import { TextFormField } from './NewSchoolDialog';
import { useCustomTheme } from '../../store/theme-context';

type Props = {
	open: boolean;
	onClose: () => void;
};

const NewDistrictDialog = ({ open, onClose }: Props) => {
	const { palette } = useTheme();
	const { isHighContrast } = useCustomTheme();
	const { token, logout } = useContext(AuthContext);
	const navigate = useNavigate();
	const { setMsg } = useContext(SnackbarContext);
	const { reset, validate, getFormData } = useContext(ManagedFormContext);
	const [sendingRequest, setSendingRequest] = useState(false);

	const handleApprove = () => {
		const validationResult = validate();
		if (validationResult) {
			setMsg({ msg: validationResult, severity: 'warning' });
			return;
		}
		setSendingRequest(true);
		if (sendingRequest) {
			return;
		}

		const formData = getFormData();
		const data = {
			name: String(formData.name || '').trim(),
		};

		addDistrict(token, data)
			.then((response) => {
				if (response.status === 200) {
					setMsg({ msg: 'Okręg został dodany', severity: 'success' });
					window.location.reload();
				} else {
					setMsg({ msg: response.data });
				}
				setSendingRequest(false);
			})
			.catch((exception) => {
				console.error(exception);
				if (exception.response.status === 401 || exception.response.status === 403) {
					logout();
					navigate(loginPage);
					setMsg({ msg: 'Nie masz uprawnień albo Twoja sesja wygasła' });
				} else if (exception?.response?.data?.message) {
					setMsg({ msg: exception?.response?.data?.message });
				}
				setSendingRequest(false);
			});
	};

	return (
		<Dialog
			open={open}
			onClose={() => {
				reset();
				onClose();
			}}
		>
			<DialogTitle sx={{ fontSize: '24px' }}>Dodaj nowy okręg</DialogTitle>
			<DialogContent>
				<Grid
					item
					container
					justifyContent={'space-between'}
				>
					<TextFormField
						fullWidth
						label={'Nazwa okręgu'}
						accessor={'name'}
					/>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button
					sx={{
						color: isHighContrast ? palette.primary.light : palette.secondary.main,
					}}
					onClick={() => {
						setTimeout(() => reset(), 500);
						onClose();
					}}
				>
					Anuluj
				</Button>
				<Button
					sx={{
						color: isHighContrast ? palette.primary.light : palette.success.main,
					}}
					onClick={() => handleApprove()}
				>
					{sendingRequest ? <CircularProgress /> : 'Zapisz'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default NewDistrictDialog;
